import React from 'react';
import ScenarioPreview from '../PaginatedScenarioPreview';

const PreviewModal = ({ template, onClose }) => {
  if (!template) return null;

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50" onClick={onClose}>
      <div className="bg-white rounded-xl p-6 w-full max-w-4xl max-h-[90vh] overflow-auto" onClick={e => e.stopPropagation()}>
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-2xl font-bold">{template.name}</h2>
          <button onClick={onClose} className="text-xl font-bold">×</button>
        </div>
        <ScenarioPreview template={template} />
      </div>
    </div>
  );
};

export default PreviewModal;
